import React, { useState } from 'react';
import api from '../utils/api';
import { useToast } from '../context/ToastContext';

export default function StatusSelect({ patient, onUpdated, compact = false }) {
  const { showToast } = useToast();
  const [saving, setSaving] = useState(false);

  async function handleChange(e) {
    const newStatus = e.target.value;
    setSaving(true);
    try {
      const res = await api.patch(`/patients/${patient._id}/status`, { status: newStatus });
      showToast('Status updated to ' + newStatus.replace('-', ' '), 'success');
      onUpdated && onUpdated(res.data.patient);
    } catch (err) {
      showToast(err.response?.data?.message || 'Could not update status.', 'error');
    } finally {
      setSaving(false);
    }
  }

  return (
    <select
      className="select"
      value={patient.status}
      onChange={handleChange}
      disabled={saving}
      style={{ width: compact ? 150 : '100%', fontWeight: 600, cursor: 'pointer' }}
    >
      <option value="waiting">Waiting</option>
      <option value="in-progress">In Progress</option>
      <option value="completed">Completed</option>
      <option value="cancelled">Cancelled</option>
    </select>
  );
}
